import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MultiSelectDropdownModule } from 'Angular/features/components/dropdowns/multi-select-dropdown/multi-select-dropdown.module';
import { SingleSelectDropdownModule } from 'Angular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { HelpModalModule } from 'Angular/features/components/modals/help-modal/help-modal.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';

import { ChartBaseListBrowserComponent } from 'ChartApp/ts/features/charts-shared/components/chart-base-list-browser/chart-base-list-browser.component';
import { ChartOptionsComponent } from 'ChartApp/ts/features/charts-shared/components/chart-options/chart-options.component';
import { ChartTypeToggleComponent } from 'ChartApp/ts/features/charts-shared/components/chart-type-toggle/chart-type-toggle.component';
import { ChartZoomControlsComponent } from 'ChartApp/ts/features/charts-shared/components/chart-zoom-controls/chart-zoom-controls.component';

@NgModule({
    declarations: [
        ChartBaseListBrowserComponent,
        ChartOptionsComponent,
        ChartTypeToggleComponent,
        ChartZoomControlsComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        HelpModalModule,
        IconModule,
        MultiSelectDropdownModule,
        SingleSelectDropdownModule,
        TooltipModule,
    ],
    exports: [
        ChartBaseListBrowserComponent,
        ChartOptionsComponent,
        ChartTypeToggleComponent,
        ChartZoomControlsComponent,
    ],
})
export class ChartsSharedModule {}
